
import { useEffect, useState } from 'react'
import Button from '../Button/Button'
import Dorpwoncustom from '../Dorpwoncustom/Dorpwoncustom'
import InputField from '../InputField/InputField'
import './FilterPasscallStyle.css'

function FilterPasscall({ isActive, setIsActive, qualificationOptions, onClick, handleChange, value }) {

    return (

        <div className={`popupWrapper poupviewtab ${isActive && "active"}`}>
            <div className="popupContainer deleteIconpoup">
                <div className="popupBody Adfilterpopup">
                    <span className="closebtn mb10">
                        <img src="/assets/svg/close.svg" alt="" onClick={() => setIsActive(false)} />
                    </span>
                    <div className="headingpoup"><h3>Filters</h3></div>
                    <div className="ContentBodyWrapperPastCall">
                        {/* <div className="InputFieldsPassCall">
                            <InputField type={'date'} className={'dateicon'} />
                        </div> */}
                        <div className="rightsidebtnCallDetails f-items-center">
                            {/* <select className="filterDrop" name='pid' >
                                <option className='menuList'>Qualification Level</option>
                                <option className='menuList' value={"pending"}>Student</option>
                                <option className='menuList' value={"completed"}>Working Professional</option>
                            </select> */}

                            <Dorpwoncustom placeholder={'Qualification Level'} options={qualificationOptions} onChange={handleChange} value={value} />
                        </div>
                        <div className="FilterButtonPassCall w-100">
                            <Button name={'Show Results'} className=" buttontext BlueFillButton w-100" onClick={onClick} />
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default FilterPasscall